<form [formGroup]=form>
    <h4 class="bk-modal__section-title">
        {{'Calculate Compost N Credits' | translate }}
    </h4>

    <mat-form-field appearance="fill"
        class="mat-form-field--one-line mat-form-field--short" >
        <mat-label>
            {{'Compost Amount' | translate }}
        </mat-label>
        <input matInput
            type="number"
            required
            name="Amount"
            formControlName="Amount" />
        <span matSuffix class="mat-form-field-suffix--padded">
            {{'tons' | translate }} /{{'acre' | translate }}
        </span>
    </mat-form-field>

    <mat-form-field appearance="fill"
        class="mat-form-field--one-line mat-form-field--short" >
        <mat-label>
            {{'N % from Compost Analysis' | translate }}
        </mat-label>
        <input matInput
            type="number"
            required
            name="N"
            formControlName="N" />
        <span matSuffix class="mat-form-field-suffix--padded">
            %
        </span>
        <mat-error *ngIf="f.N.invalid && (f.N.dirty || f.N.touched)">
            {{'Field is invalid' | translate }}
        </mat-error>
    </mat-form-field>

    <mat-form-field  appearance="fill">

        <mat-label>
            {{'Application Method' | translate }}
        </mat-label>

        <mat-select required
            name="ApplicationMethod"
            formControlName="ApplicationMethod">

            <mat-option *ngFor="let method of applicationMethods"
                [value]="method.key">
                {{method.value}}
            </mat-option>

        </mat-select>
    </mat-form-field>

    <!-- footer -->
    <div class="bk-modal__section-buttons">
        <button class="bk-button bk-button--medium bk-button--text-only"
            (click)="cancel($event)">
            {{'Cancel' | translate }}
        </button>
        <button class="bk-button bk-button--medium"
            [disabled]='form.invalid'
            (click)="calculate($event)">
            {{'Calculate' | translate }}
        </button>
    </div>
</form>